import { EX8044 } from 'config/flags';

export const inputSearchRecordsetFormat = (recordset) => {
    return recordset.map(({ _source, _id }) => {
        return {
            label: _source.description,
            value: _id,
            _source: {
                ean: [_source.ean[0]],
                description: _source.description,
            },
            laboratory: _source.laboratory,
            drug: _source.drug,
            recent_price: _source.recent_price,
        };
    });
};

export const newInputSearchRecordsetFormat = (recordset) => {
    if (!recordset) return [];
    return recordset.map(({ _source, _id }) => {
        return {
            label: _source.name,
            value: _id,
            _source: {
                ean: [_source.ean[0]],
                description: EX8044 ? _source.description : _source.name,
                refrigerated: _source?.refrigerated,
            },
            laboratory: _source.laboratory,
            drug: _source.drug,
            recent_price: _source.recent_price,
            presentation: _source.presentation,
        };
    });
};
